import { useState } from "react";
import { Form, Field } from "react-final-form";
import InputText from "@components/Form/InputText";
import Button from "@components/Button";
import Textarea from "@components/Form/Textarea";
import { leadCollectorApi } from "@lib/api";
import {
  composeFormValidators,
  isRequired,
  hasMinLength,
  hasMaxLength,
  isEmail,
} from "@lib/validations";

const ContactForm = ({ user, formId }) => {
  const [sent, setSent] = useState(false);
  const [error, setError] = useState();
  const { isInitial, customer } = user;

  const handleContactSubmit = async (values) => {
    const { status, originalError } = await leadCollectorApi(values);
    if (status === 200) setSent(true);
    else setError(originalError);
  };

  return (
    <div className="flex items-start justify-start w-full space-y-4 md:pl-32">
      <Form
        onSubmit={(values) => handleContactSubmit(values)}
        initialValues={{
          //! That double render will return `undefined undefined` just into the
          //! first field `name` of this object if using the ternary conditional on it
          //! Until the validation reaches the `email` key the second render already
          //! with the correct user information. THAT DOUBLE RENDER IS NOT NORMAL!
          fc_target: formId,
          name: `${customer?.first_name || ""} ${customer?.last_name || ""}`,
          email: !isInitial ? customer?.email : "",
        }}
        render={({ handleSubmit, submitting, pristine, invalid }) => (
          <form
            className="flex flex-col space-y-5 w-full"
            onSubmit={handleSubmit}
          >
            <div className="w-full">
              <Field
                className="!w-full !max-w-full"
                name="name"
                label="Nume"
                type="text"
                component={InputText}
                required
                validate={composeFormValidators(
                  isRequired(),
                  hasMinLength(3),
                  hasMaxLength(100)
                )}
              />
            </div>
            <div className="w-full">
              <Field
                className="!w-full !max-w-full"
                name="email"
                label="Email"
                type="email"
                component={InputText}
                required
                validate={composeFormValidators(isRequired(), isEmail())}
              />
            </div>
            <div className="w-full">
              <Field
                className="!w-full !max-w-full"
                name="company"
                label="Nume companie"
                type="text"
                component={InputText}
                required
                validate={composeFormValidators(isRequired(), hasMaxLength(60))}
              />
            </div>
            <div className="w-full">
              <Field
                className="!w-full !max-w-full"
                name="subject"
                label="Subiect mesaj"
                type="text"
                component={InputText}
                required
                validate={composeFormValidators(
                  isRequired(),
                  hasMinLength(1),
                  hasMaxLength(100)
                )}
              />
            </div>
            <div className="w-full">
              <Field
                className="!w-full !max-w-full"
                name="message"
                label="Mesaj"
                type="textarea"
                component={Textarea}
                required
                validate={composeFormValidators(
                  isRequired(),
                  hasMinLength(1),
                  hasMaxLength(3000)
                )}
              />
            </div>
            {sent && (
              <div
                className={`flex items-center justify-between w-full px-3.5 py-3 rounded-tr-lg rounded-bl-lg ${
                  error ? "bg-alertRed-bg/25" : "bg-[#62D040]/25"
                }`}
              >
                <p
                  className={`text-sm font-medium ${
                    error ? "text-alertRed" : "text-[#319D10]"
                  }`}
                >
                  {error
                    ? "Cererea nu a putut fi inregistrata. Incercati din nou."
                    : "Cererea a fost inregistrata cu succes!"}
                </p>
                <div
                  className={`flex items-center justify-center rounded-full w-4 h-4 ${
                    error ? "bg-alertRed" : "bg-[#319D10]"
                  } cursor-pointer`}
                  onClick={() => setSent(false)}
                >
                  <svg className="w-2 h-2" version="1.1" viewBox="0 0 512 512">
                    <polygon
                      fill="#FFFFFF"
                      points="512,59.076 452.922,0 256,196.922 59.076,0 0,59.076 196.922,256 0,452.922 59.076,512 256,315.076 452.922,512 512,452.922 315.076,256"
                    />
                  </svg>
                </div>
              </div>
            )}
            <div className="w-full md:w-44">
              <Button
                title="Trimite"
                type="submit"
                display="block"
                isOrderAgain={true}
                disabled={submitting || pristine || invalid}
                variant="secondary"
                hasMinWidth={false}
              />
            </div>
          </form>
        )}
      />
    </div>
  );
};

export default ContactForm;
